<template>
  <div>
    <div v-if="getUser">
      <a @click="likeAction" v-if="postLiked"><font-awesome-icon class="has-text-danger" :icon="['fas', 'heart']" size="lg" /></a>
      <a @click="likeAction" v-else><font-awesome-icon class="has-text-danger" :icon="['far', 'heart']" size="lg" /></a>
      <span class="has-text-danger is-size-7"> {{ userCount }} إعجاب</span>
    </div>
    <div v-else>
      <font-awesome-icon v-if="userCount > 0" class="has-text-danger" :icon="['fas', 'heart']" size="lg" />
      <font-awesome-icon v-else class="has-text-danger" :icon="['far', 'heart']" size="lg" />
      <span class="has-text-danger is-size-7"> {{ userCount }} إعجاب</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeart } from '@fortawesome/free-regular-svg-icons'
import { faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons'
library.add(faHeart, faHeartSolid)

export default {
  data () {
    return {
      likeId: null,
      postLiked: false,
      userCount: 0
    }
  },
  created () {
    this.getLikes()
  },
  methods: {
    getLikes: function () {
      let params = {
        appid: this.$store.state.config.XbAppID,
        type: 'data',
        request: 'km_likes',
        getby: `postId:${this.post}`
      }
      this.XbortGetRequest('', params, result => {
        if (result.result) {
          this.likeId = result.data[0]._id
          if (result.data[0].users && result.data[0].users.length > 0) {
            if (result.data[0].users.includes(this.getUser)) {
              this.postLiked = true
            }
            this.userCount = result.data[0].users.length
          } else {
            this.postLiked = false
            this.userCount = 0
          }
        }
      })
    },
    likeAction: function () {
      // Only if post has already been liked
      let method = 'put'
      let params = {}
      if (this.postLiked) {
        // Remove like
        // update likes
        method = 'delete'
        params = {
          appid: this.$store.state.config.XbAppID,
          type: 'data',
          request: 'km_likes',
          id: this.likeId,
          record: `users-${this.getUser}`
        }
      } else {
        method = 'post'
        if (this.likeId) {
          params = {
            appid: this.$store.state.config.XbAppID,
            type: 'data',
            request: 'km_likes',
            id: this.likeId,
            record: 'users',
            data: this.getUser
          }
        } else {
          params = {
            appid: this.$store.state.config.XbAppID,
            type: 'data',
            request: 'km_likes',
            data: JSON.stringify({
              postId: this.post,
              users: [this.getUser]
            })
          }
        }
      }
      this.XbortRequest('', method, params, result => {
        if (result.result) {
          // update likes
          this.getLikes()
          this.successSave()
        } else {
          this.errorMessage(result.data)
        }
      })
    }
  },
  props: [
    'post'
  ],
  computed: {
    ...mapGetters([
      'getUser'
    ])
  }
}
</script>
